import { useEffect, useRef } from "react";
import { BiLink } from "react-icons/bi";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useParams } from "react-router-dom";
import { useGlobalContext } from "../../context";
import "./projectpage.css";

const ProjectPage = () => {
  let { id } = useParams();
  id = parseInt(id);
  const { projects } = useGlobalContext();
  const project = projects.find((project) => project.id === id);

  const intervalRef = useRef();

  let curImage = 0;
  const setImage = (direction = "r", images) => {
    if (direction === "l") {
      curImage--;
      if (curImage < 0) {
        curImage = project.images.length - 1;
      }
    } else {
      curImage++;
      if (curImage > project.images.length - 1) {
        curImage = 0;
      }
    }
    images[curImage].style.opacity = "1";
  };

  useEffect(() => {
    let images = document.getElementsByClassName("carouselImg");
    if (images.length > 1) {
      images[curImage].style.opacity = "1";

      intervalRef.current = setInterval(() => {
        images[curImage].style.opacity = "0";
        setImage("r", images);
      }, 8000);
    }
    return () => {
      clearInterval(intervalRef.current);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="projectPageContainer">
        <div
          className="projectTitle fadeDown"
          style={{ animateDelay: "200ms" }}
        >
          {project.title}
        </div>
        <div className="carouselMain">
          {project.images.length > 1 ? (
            <IoIosArrowBack
              className="projectPageDirectionLeft"
              onClick={() => {
                let images = document.getElementsByClassName("carouselImg");
                images[curImage].style.opacity = "0";

                setImage("l", images);
              }}
            />
          ) : (
            ""
          )}
          <div className="carouselContainer">
            <img
              src={process.env.PUBLIC_URL + "/projects/frame.jpg"}
              alt="frame"
              className="carouselImgFrame"
            />
            {project.images.length > 1 ? (
              project.images.map((image, index) => (
                <img
                  src={process.env.PUBLIC_URL + image}
                  key={index}
                  alt="carouselImg"
                  className="carouselImg"
                  onClick={() => {
                    window.open(process.env.PUBLIC_URL + image);
                  }}
                />
              ))
            ) : (
              <img
                src={project.images[0]}
                alt="carouselImg"
                className="carouselImg"
                style={{ opacity: "1" }}
              />
            )}
          </div>
          {project.images.length > 1 ? (
            <IoIosArrowForward
              className="projectPageDirectionRight"
              onClick={() => {
                let images = document.getElementsByClassName("carouselImg");
                images[curImage].style.opacity = "0";

                setImage("r", images);
              }}
            />
          ) : (
            ""
          )}
        </div>
        <div className="projectDetailsContainer">
          <h2 className="aboutHead">About the Project</h2>
          <div className="projectPageDesc">{project.desc}</div>

          <div>
            <h2>Tech used</h2>
            <ul className="techList">
              {project.tech.map((item, index) => (
                <li className="techItem" key={index}>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="projectLink">
            <a
              href={project.link}
              target="_blank"
              className="projectLinkAchor"
              rel="noreferrer"
            >
              <h4>Check it out!</h4>
              <BiLink className="projectLinkIcon" />
            </a>
          </div>

          {project.youtube && (
            <div className="youtubeContainer">
              <iframe
                className="youtubeIframe"
                src={project.youtube}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          )}

          <div className="projectLists">
            {project.lists &&
              Object.keys(project.lists).map((list, index1) => (
                <div className="projectListContainer" key={index1}>
                  <h1 className="projectListHead">{list}</h1>
                  <ul className="projectList">
                    {project.lists[list].map((item, index2) => {
                      return (
                        <div className="listItem" key={index2}>
                          <span className="projectArrow">&#10173;</span>
                          <li key={index2}>{item}</li>
                        </div>
                      );
                    })}
                  </ul>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectPage;
